"use strict"; // Copyright (C) 2021 Toitware ApS. All rights reserved.
// Use of this source code is governed by an MIT-style license that can be
// found in the LICENSE file.

var _regeneratorRuntime = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _getPrototypeOf = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _createSuper = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncToGenerator = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTransientError = exports.toHex = exports.toByteArray = exports.Uint8BufferSlipEncode = exports.Uint8Buffer = exports.sleep = void 0;

function sleep(_x) {
  return _sleep.apply(this, arguments);
}

function _sleep() {
  _sleep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ms) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(resolve, ms);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sleep.apply(this, arguments);
}

exports.sleep = sleep;

var Uint8Buffer = /*#__PURE__*/function () {
  function Uint8Buffer() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 64;

    _classCallCheck(this, Uint8Buffer);

    this.readOffset = 0;
    this.writeOffset = 0;
    this.size = size;
    this._buffer = new ArrayBuffer(this.size);
    this._view = new Uint8Array(this._buffer);
  }

  _createClass(Uint8Buffer, [{
    key: "shift",
    value: function shift() {
      if (this.length <= 0) {
        return undefined;
      }

      return this._view[this.readOffset++];
    }
  }, {
    key: "grow",
    value: function grow(newSize) {
      var newBuffer = new ArrayBuffer(newSize);
      var newView = new Uint8Array(newBuffer);
      newView.set(this._view, 0);
      this.size = newSize;
      this._buffer = newBuffer;
      this._view = newView;
    }
  }, {
    key: "fill",
    value: function fill(element) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.ensure(length);

      this._view.fill(element, this.writeOffset, this.writeOffset + length);

      this.writeOffset += length;
    }
  }, {
    key: "ensure",
    value: function ensure(length) {
      if (this.size - this.writeOffset < length) {
        var newSize = this.size + Math.max(length, this.size);
        this.grow(newSize);
      }
    }
  }, {
    key: "pushBytes",
    value: function pushBytes(value, byteCount, littleEndian) {
      for (var i = 0; i < byteCount; i++) {
        if (littleEndian) {
          this.push(value >> i * 8 & 0xff);
        } else {
          this.push(value >> (byteCount - i) * 8 & 0xff);
        }
      }
    }
  }, {
    key: "pack",
    value: function pack(format) {
      var pointer = 0;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var data = args;

      if (format.replace(/[<>]/, "").length != data.length) {
        throw "Pack format to Argument count mismatch";
      }

      var littleEndian = true;

      for (var i = 0; i < format.length; i++) {
        if (format[i] == "<") {
          littleEndian = true;
        } else if (format[i] == ">") {
          littleEndian = false;
        } else if (format[i] == "B") {
          this.pushBytes(data[pointer], 1, littleEndian);
          pointer++;
        } else if (format[i] == "H") {
          this.pushBytes(data[pointer], 2, littleEndian);
          pointer++;
        } else if (format[i] == "I") {
          this.pushBytes(data[pointer], 4, littleEndian);
          pointer++;
        } else {
          throw "Unhandled character in pack format";
        }
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.writeOffset = 0;
      this.readOffset = 0;
    }
  }, {
    key: "push",
    value: function push() {
      for (var _len2 = arguments.length, bytes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        bytes[_key2] = arguments[_key2];
      }

      this.ensure(bytes.length);

      this._view.set(bytes, this.writeOffset);

      this.writeOffset += bytes.length;
    }
  }, {
    key: "copy",
    value: function copy(bytes) {
      this.ensure(bytes.length);

      this._view.set(bytes, this.writeOffset);

      this.writeOffset += bytes.length;
    }
    /**
     * @name packet
     * returns the bytes between two 0xc0 bytes.
     */

  }, {
    key: "packet",
    value: function packet() {
      var dataStart;
      var dataEnd;

      for (var i = this.readOffset; i < this.writeOffset; i++) {
        if (this._view[i] === 0xc0) {
          if (dataStart === undefined) {
            dataStart = i + 1; // Empty package, normally because of wrong start marker.
          } else if (dataStart === i) {
            dataStart = i + 1;
          } else {
            dataEnd = i;
            break;
          }
        }
      }

      if (dataEnd === undefined || dataStart === undefined) {
        return undefined;
      }

      this.readOffset = dataEnd + 1;
      var res = new Uint8Array(this._buffer, dataStart, dataEnd - dataStart);

      if (this.readOffset == this.writeOffset) {
        this.reset();
      }

      return res;
    }
  }, {
    key: "view",
    value: function view() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var res = new Uint8Array(this._buffer, this.readOffset, this.writeOffset);

      if (reset) {
        this.reset();
      }

      return res;
    }
  }, {
    key: "length",
    get: function get() {
      return this.writeOffset - this.readOffset;
    }
  }]);

  return Uint8Buffer;
}();

exports.Uint8Buffer = Uint8Buffer;
/**
 * @name Uint8BufferSlipEncode
 * makes a Uint8Buffer with slipEncoding mechanisms.
 * When slipEncode is enabled it:
 *  * replaces 0xdb with 0xdb 0xdd
 *  * and 0xc0 with 0xdb 0xdc
 * for all write operations.
 */

var Uint8BufferSlipEncode = /*#__PURE__*/function (_Uint8Buffer) {
  _inherits(Uint8BufferSlipEncode, _Uint8Buffer);

  var _super = _createSuper(Uint8BufferSlipEncode);

  function Uint8BufferSlipEncode() {
    var _this;

    _classCallCheck(this, Uint8BufferSlipEncode);

    _this = _super.apply(this, arguments);
    _this.slipEncode = false;
    return _this;
  }

  _createClass(Uint8BufferSlipEncode, [{
    key: "push",
    value: function push() {
      var _this2 = this;

      for (var _len3 = arguments.length, bytes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        bytes[_key3] = arguments[_key3];
      }

      if (!this.slipEncode) {
        var _get2;

        (_get2 = _get(_getPrototypeOf(Uint8BufferSlipEncode.prototype), "push", this)).call.apply(_get2, [this].concat(bytes));
      } else {
        bytes.forEach(function (v) {
          return _this2.slipEncodeByte(v);
        });
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.slipEncode = false;

      _get(_getPrototypeOf(Uint8BufferSlipEncode.prototype), "reset", this).call(this);
    }
  }, {
    key: "copy",
    value: function copy(bytes) {
      var _this3 = this;

      if (!this.slipEncode) {
        _get(_getPrototypeOf(Uint8BufferSlipEncode.prototype), "copy", this).call(this, bytes);
      } else {
        bytes.forEach(function (v) {
          return _this3.slipEncodeByte(v);
        });
      }
    }
    /**
     * @name packet
     * returns the bytes between two 0xc0 bytes.
     * decodes slip encoding
     */

  }, {
    key: "packet",
    value: function packet() {
      var slipDecode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var res = _get(_getPrototypeOf(Uint8BufferSlipEncode.prototype), "packet", this).call(this);

      if (res === undefined || !slipDecode) {
        return res;
      }

      var writeOffset = 0;

      for (var i = 0; i < res.byteLength; i++) {
        if (res[i] == 0xdb && i + 1 < res.byteLength && res[i + 1] == 0xdd) {
          res[writeOffset++] = 0xdb;
          i++;
        } else if (res[i] == 0xdb && i + 1 < res.byteLength && res[i + 1] == 0xdc) {
          res[writeOffset++] = 0xc0;
          i++;
        } else {
          res[writeOffset++] = res[i];
        }
      }

      res.slice(0, writeOffset);
      return res;
    }
    /**
     * @name slipEncodeByte
     * Replaces 0xdb with 0xdb 0xdd and 0xc0 with 0xdb 0xdc
     */

  }, {
    key: "slipEncodeByte",
    value: function slipEncodeByte(v) {
      if (v == 0xdb) {
        _get(_getPrototypeOf(Uint8BufferSlipEncode.prototype), "push", this).call(this, 0xdb, 0xdd);
      } else if (v == 0xc0) {
        _get(_getPrototypeOf(Uint8BufferSlipEncode.prototype), "push", this).call(this, 0xdb, 0xdc);
      } else {
        _get(_getPrototypeOf(Uint8BufferSlipEncode.prototype), "push", this).call(this, v);
      }
    }
  }]);

  return Uint8BufferSlipEncode;
}(Uint8Buffer);

exports.Uint8BufferSlipEncode = Uint8BufferSlipEncode;

function toByteArray(str) {
  var byteArray = new Uint8Array(str.length);

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);
    byteArray[i] = charcode & 0xff;
  }

  return byteArray;
}

exports.toByteArray = toByteArray;

function toHex(value) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return "0x" + value.toString(16).toUpperCase().padStart(size, "0");
}

exports.toHex = toHex;

function isTransientError(e) {
  if (e instanceof DOMException) {
    return e.name === "BufferOverrunError" || e.name === "BreakError" || e.name === "FramingError" || e.name === "ParityError";
  }

  return false;
}

exports.isTransientError = isTransientError;